export default __webpack_public_path__ + "static/media/DOM-OCT2024.53f0ccd6.png";